export default {
  'global': {
    'send': 'Envoyer',
    'save': 'Enregister',
    'confirm': 'Confirmer',
    'cancel': 'Annuler',
    'brand': 'HeiGIT - Heidelberg University',
    'close': 'Fermer',
    'closeAndDoNotShowAgain': 'Fermer et ne plus montrer',
    'select': 'Sélectionner',
    'yes': 'Oui',
    'no': 'Non',
    'and': 'et',
    'noAndDonAskAgain': 'Non (et ne plus demander)',
    'ok': 'OK',
    'polygon': 'polygone',
    'developedByIntro': 'Services développés par',
    'developedBy': 'Heidelberg Institute for Geoinformation Technology (HeiGIT)',
    'duration': 'Durée',
    'distance': 'Distance',
    'elevation': 'Élévation',
    'profile': 'Profil',
    'options': 'Options',
    'parameters': 'Paramètres',
    'custom': 'Personnalisé',
    'customOverlayer': 'Superposition personnalisée',
    'rawRouting': 'Routage brut',
    'months': {
      'january': 'Janvier',
      'february': 'février',
      'march': 'Mars',
      'april': 'Avril',
      'may': 'Mai',
      'june': 'Juin',
      'july': 'Juillet',
      'august': 'Août',
      'september': 'Septembre',
      'october': 'Octobre',
      'november': 'Novembre',
      'december': 'Décembre'
    },
    'monthsShort': {
      'january': 'Jan',
      'february': 'Fev',
      'march': 'Mar',
      'april': 'Avr',
      'may': 'Mai',
      'june': 'Juin',
      'july': 'Juil',
      'august': 'Aoû',
      'september': 'Sep',
      'october': 'Oct',
      'november': 'Nov',
      'december': 'Dec'
    },
    'units': {
      'km': 'km(s)',
      'mi': 'mi(s)',
      'm': 'm',
      'seconds': 'sec',
      's': 's',
      'minutes': 'min',
      'hours': 'h',
      'min': 'min',
      'days': 'J',
      'meters': 'mètres',
      'lat': 'lat',
      'lng': 'long',
      'kmh': 'km/h',
      'tones': 'tonnes',
      't': 't',
    },
    'layers': {
      'macrocounty': 'Macro comté',
      'country': 'Pays',
      'region': 'Région',
      'county': 'Comté',
      'macroregion': 'Macro région',
      'neighbourhood': 'Quartier',
      'locality': 'Localité',
      'borough': 'Arrondissement',
      'localadmin': 'Administration locale',
      'address': 'Adresse',
      'street': 'Rue',
      'venue': 'Lieu',
      'rawCoordinate': 'Brutes lon. et lat. coordonnées',
      'notAvailable': 'Pas disponible',
      'postalcode': 'Code postal',
      'undefined': 'Non défini',
      'ocean': 'Océan'
    },
    'population': 'Population',
    'green': 'Vert',
    'noise': 'Bruit',
    'steepness': 'Inclinaison',
    'surface': 'Surface',
    'roadaccessrestrictions': 'Restrictions d\'accès à la route',
    'waytypes': 'Types de voie',
    'suitability': 'pertinence',
    'waycategory': 'Catégorie de voie',
    'tollways': 'Péages',
    'traildifficulty': 'Difficulté du sentier',
    'osmid': 'OSM ID',
    'countryinfo': 'Informations sur le pays'
  }
}
